import { render } from "./ListOfClasses.vue?vue&type=template&id=3704b721&scoped=true&ts=true"
import script from "./ListOfClasses.ts?vue&type=script&lang=ts"
export * from "./ListOfClasses.ts?vue&type=script&lang=ts"

import "./ListOfClasses.vue?vue&type=style&index=0&id=3704b721&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3704b721"]])

export default __exports__